/* import __COLOCATED_TEMPLATE__ from './appointments-feature-details-popover.hbs'; */
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { readOnly } from '@ember/object/computed';
import { UPSELL_TYPE } from '@square/appointments-feature-upsell/constants';
import { upsellTrackingData } from '@square/appointments-feature-upsell/utils/events';
let AppointmentsFeatureDetailsPopoverComponent = (_dec = readOnly('planDetailForFeature.name'), _dec2 = readOnly('planDetailForFeature.priceInCent'), _dec3 = readOnly('planDetailForFeature.currencyCode'), _dec4 = readOnly('planDetailForFeature.freeTrialDaysLeft'), _class = class AppointmentsFeatureDetailsPopoverComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "appointmentsFeatureInfo", _descriptor, this);
    _initializerDefineProperty(this, "appointmentsSubscription", _descriptor2, this);
    _initializerDefineProperty(this, "dataApi", _descriptor3, this);
    _initializerDefineProperty(this, "intl", _descriptor4, this);
    _initializerDefineProperty(this, "router", _descriptor5, this);
    _initializerDefineProperty(this, "appointmentsSubscriptionModal", _descriptor6, this);
    _initializerDefineProperty(this, "internalIsFeatureDetailsModalOpen", _descriptor7, this);
    _initializerDefineProperty(this, "planName", _descriptor8, this);
    _initializerDefineProperty(this, "planPriceInCent", _descriptor9, this);
    _initializerDefineProperty(this, "currencyCode", _descriptor10, this);
    _initializerDefineProperty(this, "planFreeTrialDaysLeft", _descriptor11, this);
  }
  get freeTrialText() {
    if (!this.appointmentsSubscription.freeTrialEndDateMonthDay) {
      return '';
    }
    const fullPlanName = this.intl.t('apptsUpsell.square.appointments.plan', {
      planName: this.planName
    });
    return this.intl.t('apptsUpsell.subscription.feature.description.freeTrial', {
      planName: fullPlanName,
      freeTrialEndDate: this.appointmentsSubscription.freeTrialEndDateMonthDay,
      htmlSafe: true
    });
  }
  get isFeatureDetailsModalOpen() {
    return this.passedIsFeatureDetailsModalOpen || this.internalIsFeatureDetailsModalOpen;
  }
  get pillText() {
    return this.appointmentsSubscription.isOnFreeSubscription ? this.intl.t('apptsUpsell.common.upgrade') : this.planName;
  }
  get showFeatureUpsellNextActionButton() {
    return this.featureHasMoreDetails || this.canManageSubscriptions;
  }
  get featureId() {
    return this.args.featureId ?? '';
  }
  get isFreeTrial() {
    return this.upsellType === UPSELL_TYPE.FREE_TRIAL;
  }
  get upsellType() {
    return this.args.upsellType ?? UPSELL_TYPE.PAYWALL;
  }
  get planDetailForFeature() {
    return this.args.planDetailForFeature ?? null;
  }
  get canManageSubscriptions() {
    return this.args.canManageSubscriptions ?? true;
  }
  get passedIsFeatureDetailsModalOpen() {
    return this.args.passedIsFeatureDetailsModalOpen ?? null;
  }
  get featureTitle() {
    return this.appointmentsFeatureInfo.getFeatureTitle(this.featureId);
  }
  get featureDescription() {
    return this.appointmentsFeatureInfo.getFeatureDescription(this.featureId);
  }
  get featureHasMoreDetails() {
    return this.appointmentsFeatureInfo.getFeatureHasMoreDetails(this.featureId);
  }
  get planToken() {
    return this.appointmentsFeatureInfo.getPlanTokenOfFeature(this.featureId);
  }
  get featureUpsellNextActionButtonText() {
    if (this.isFreeTrial) {
      return this.intl.t('apptsUpsell.common.subscribeTo', {
        planName: this.planName
      });
    }
    return this.featureHasMoreDetails ? this.intl.t('apptsUpsell.common.learnMore') : this.planFreeTrialDaysLeft === 0 ? this.intl.t('apptsUpsell.common.subscribeTo', {
      planName: this.planName
    }) : this.intl.t('apptsUpsell.common.tryFree', {
      planName: this.planName
    });
  }
  dismissUpsellModal() {
    this.args.dismissFeatureDetailsModal?.();
    this.internalIsFeatureDetailsModalOpen = false;
  }
  openSubscriptionModal() {
    if (this.planToken) {
      this.appointmentsSubscriptionModal.open({
        planToken: this.planToken,
        subscriptionToken: this.appointmentsSubscription.token
      }).then(({
        didSubscribe
      }) => {
        if (didSubscribe) {
          window.location.reload();
        }
      });
    }
  }
  featureUpsellNextAction() {
    let item_clicked = 'subscribe';
    if (!this.isFreeTrial && this.featureHasMoreDetails) {
      item_clicked = 'learn_more';
    }
    const trackingData = {
      ...upsellTrackingData({
        routerService: this.router,
        planToken: this.planToken,
        featureId: this.featureId,
        upsellType: this.upsellType,
        hasUsedFreeTrial: this.planFreeTrialDaysLeft === 0
      }),
      item_clicked
    };
    this.dataApi.track('Click Subscription Entry Point', trackingData);
    if (this.isFreeTrial) {
      this.openSubscriptionModal();
      return;
    }
    if (this.featureHasMoreDetails) {
      this.internalIsFeatureDetailsModalOpen = true;
      this.dataApi.track('Click Page', {
        platform: 'web',
        item_clicked: 'feature upsell',
        subscription_state: this.appointmentsSubscription.status,
        plan_token: this.appointmentsSubscription.planToken,
        feature: this.featureId
      });
    } else {
      this.openSubscriptionModal();
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "appointmentsFeatureInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "appointmentsSubscription", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "appointmentsSubscriptionModal", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "internalIsFeatureDetailsModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "planName", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "planPriceInCent", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "currencyCode", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "planFreeTrialDaysLeft", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "dismissUpsellModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dismissUpsellModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openSubscriptionModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openSubscriptionModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "featureUpsellNextAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "featureUpsellNextAction"), _class.prototype), _class);
export { AppointmentsFeatureDetailsPopoverComponent as default };